import {useLocation} from 'react-router-dom';

import useNavigateReplace from '../../hooks/useNavigateReplace';
import featuresService from '../../services/features/featuresService';
import {t} from '../../services/localization/localizationService';
import NavigationBarTab from './NavigationBarTab';

const NavigationBarItem = (props) => {
    const {icon: Icon, route, buttonStr, featureCode, excludedFeatureCode} = props;
    const {pathname} = useLocation() || {};
    const isActive = pathname.includes(route);
    const navigate = useNavigateReplace();
    const isEnabled = featureCode ? featuresService.getIsFeatureEnabled(featureCode) : true;
    const isExcluded = excludedFeatureCode && featuresService.getIsFeatureEnabled(excludedFeatureCode);

    if (!isEnabled) return null;

    if (isExcluded) return null;

    const onTabClick = () => {
        navigate(route);
    };

    return (
        <NavigationBarTab
            onClick={onTabClick}
            rumActionName={route}
            isActive={isActive}
            icon={<Icon isActive={isActive} className={isActive ? 'stroke h-6 w-6' : 'h-7 w-7'} />}
            label={t(buttonStr)}
        />
    );
};

export default NavigationBarItem;
